type Categories = {
    id: number,
    categoryName: string,
    coverImgSrc : string
}

export const categoriesData: Categories[] = [
    {
        id: 1,
        categoryName: "Books",
        coverImgSrc: "https://www.frontlist.in/storage/uploads/2021/07/shutterstock_135114548.jpg"
    },
    {
        id: 2,
        categoryName: "Sports",
        coverImgSrc: "https://thumbs.dreamstime.com/b/assorted-sports-equipment-black-11153245.jpg"
    },
    {
        id:3,
        categoryName: "Films",
        coverImgSrc: "https://c4.wallpaperflare.com/wallpaper/22/762/507/film-movie-filmmaker-movie-director-wallpaper-preview.jpg"
    },
    {
        id: 4,
        categoryName: "Mythology",
        coverImgSrc: "https://assets.ltkcontent.com/images/88899/mythology-greek-statues_5c3b4ec84b.jpg"
    },
    {
        id: 5,
        categoryName: "Animals",
        coverImgSrc: "https://i2-prod.irishmirror.ie/incoming/article5480725.ece/ALTERNATES/s615b/lion-photographer.jpg"
    },
    {
        id: 6,
        categoryName: "Comics",
        coverImgSrc: "https://i.etsystatic.com/17116666/r/il/852b41/3646403689/il_fullxfull.3646403689_d8u7.jpg"
    }
]
